import Vue from 'vue'
import Vuex from 'vuex'
import operations from './modules/operations'
import calculation from './modules/calculation'
import roomParams from './modules/roomParams'
import houseParams from './modules/houseParams'
import user from './modules/user'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({

  modules: {
    operations,
    room: calculation,
    house: calculation,
    roomParams,
    houseParams,
    user
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js